import React, { useState, useEffect, useRef } from 'react';
import NoSSR from "@/utils/no-ssr";
import { Input } from "@progress/kendo-react-inputs";
import SCHint from '@/components/sc-controls/form-controls/sc-hint';
import { layout } from '@/theme';
import Helper from '@/utils/helper';
import ScTextControl from "@/components/sc-controls/form-controls/v2/sc-text-control";
import {SCInputProps} from "@/components/sc-controls/form-controls/sc-control-interfaces";
import ScPasswordControl from "@/components/sc-controls/form-controls/v2/sc-password-control";
import ScNumberControl from "@/components/sc-controls/form-controls/v2/sc-number-control";
import ScMobileNumberControl from "@/components/sc-controls/form-controls/v2/sc-mobile-number-control";
import {InputProps, NumberInputProps, PasswordInputProps, TextInputProps} from "@mantine/core";

const useKendo = false;

function SCInput(inputProps: SCInputProps) {

    const {
        name, value, label, hint, autoSelect = false, autoFocus = false, required = false,
        readOnly = false, disabled = false, type = 'text', error, onChange, onPaste, tabIndex, extraClasses, 
        cypress, onKeyPress, onFocus, placeholder, onBlur, min, mt = 'sm'
    } = inputProps;

    const mantineSafeInputProps: InputProps | NumberInputProps = {
        name,
        value,
        label,
        withAsterisk: required,
        readOnly,
        disabled,
        type,
        error,
        tabIndex,
        onPaste,
        autoFocus,
        onFocus,
        placeholder,
        onBlur, 
        min,
        mt
    }


    const ref = useRef<HTMLInputElement>(null);

    const handleOnFocus = (e: any) => {

    };

    const handleOnPaste = async (e: any) => {
        await Helper.waitABit();
        if (onPaste) {
            onPaste(e.target.value);
        }
    };

    useEffect(() => {
        if (autoSelect && ref.current) {
            ref.current.select();
        }
    }, [autoSelect]);

    let inputName = Helper.newGuid() + "-autocomplete-off";

    const handleInputChangeTextMantine = (e: any) => {
        onChange && onChange({...e, target: e.nativeEvent.target, name: name, value: e.currentTarget.value});
    };

    const handleInputChangeNumberMantine = (val: any) => {
        onChange && onChange({target: ref.current, name: name, value: val});
    };

    const handleInputKendo = (e: any) => {
        onChange && onChange({target: e.target.element, name: name, value: e.value});
    };

    const [revealPassword, setRevealPassword] = useState(false);
    const [isPasswordType, setIsPasswordType] = useState(type === 'password');


    return (
        type === 'password' &&
        <ScPasswordControl
            {...mantineSafeInputProps as PasswordInputProps}
            type={undefined}
            onChange={handleInputChangeTextMantine}
            name={inputName}
            value={value}
            onKeyPress={(e: any) => onKeyPress && onKeyPress(e)}
            onBlur={onBlur}
        /> ||
        type === 'number' &&
        <ScNumberControl
            hideControls
            {...mantineSafeInputProps}
            onChange={handleInputChangeNumberMantine}
            name={inputName}
            value={value}
            decimalScale={4}
            // removeTrailingZeros
            onKeyPress={(e: any) => onKeyPress && onKeyPress(e)}
            onBlur={onBlur}
            min={min}
        /> ||
        type === 'tel' &&
        <ScMobileNumberControl
            {...mantineSafeInputProps}
            onChange={handleInputChangeTextMantine}
            name={inputName}
            value={value}
            onKeyPress={(e: any) => onKeyPress && onKeyPress(e)}
            onBlur={onBlur}
        /> ||
        <ScTextControl {...mantineSafeInputProps as TextInputProps}
                       onChange={handleInputChangeTextMantine}
                       name={inputName}
                       value={value}
                       onKeyPress={(e: any) => onKeyPress && onKeyPress(e)}
                       description={hint}
                       onBlur={onBlur}
        />
    );
}

export default SCInput;
